import { render, staticRenderFns } from "./TabGlass.vue?vue&type=template&id=86c18f18&scoped=true&"
import script from "./TabGlass.vue?vue&type=script&lang=js&"
export * from "./TabGlass.vue?vue&type=script&lang=js&"
import style0 from "./TabGlass.vue?vue&type=style&index=0&id=86c18f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c18f18",
  null
  
)

export default component.exports